import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';

import { Title } from 'shared';
import { useTranslation } from 'hooks/useTranslation';

import { AvailableUserBalance } from 'features/finance/components/AvailableUserBalance';
import { UserOtherBalances } from 'features/finance/components/UserOtherBalances';
import { TopUpHistory } from 'features/finance/components/TopUpHistory';
import { usePartnerBalanceQuery } from 'features/app/hooks/usePartnerBalanceQuery';
import { appRoutes } from 'features/app/routes/paths';

import { useStyles } from './styles';
import useUser from 'features/user/hooks/useUser';

export const BalanceAndTopUpPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation('app');
  const { user } = useUser();

  const { data: partnerBalance } = usePartnerBalanceQuery();

  useEffect(() => {
    user?.registration_request_status !== 'APPROVED' && history.push(appRoutes.static.root);
  }, [user, history]);

  return (
    <>
      <Title title={t('balanceAndTopUp')} />

      <Box className={classes.balancesWrapper} flex={1} display="flex" justifyContent="space-between">
        <AvailableUserBalance partnerBalance={partnerBalance} />
        <UserOtherBalances partnerBalance={partnerBalance} />
      </Box>

      <Box className={classes.topUpHistoryWrapper}>
        <TopUpHistory />
      </Box>
    </>
  );
};
